<template>
  <div class="bloc">
    <h4 style="text-align:center; font-size:16px;">
      {{ $t("translation.flags-text") }}
    </h4>
    <hr style="margin:10px 0px; height:0.25px; background-color:#999999" />
    <div style="padding:0px 20px 20px 20px;" class="columns is-mobile">
      <div
      style="text-align: center;"
        v-if="this.$store.state.sondage.languagesAdmin.includes('fr')"
        @click="choosenLanguageClient('fr')"
        class="column is-one-quarters-mobile"
        ><img class="icon-flag" src="~@/assets/img/flag_translation/fr-2.png" /></div
      >

      <div
        style="text-align: center;"
        v-if="this.$store.state.sondage.languagesAdmin.includes('en')"
        @click="choosenLanguageClient('en')"
        class="column is-one-quarters-mobile"
      >
        <img class="icon-flag" src="~@/assets/img/flag_translation/en-2.png" />
      </div>
      <div
        style="text-align: center;"
        v-if="this.$store.state.sondage.languagesAdmin.includes('es')"
        @click="choosenLanguageClient('es')"
        class="column is-one-quarters-mobile"
      >
        <img class="icon-flag" src="~@/assets/img/flag_translation/es-2.png" />
      </div>
      <!-- DE -->
      <div
        style="text-align: center;"
        v-if="this.$store.state.sondage.languagesAdmin.includes('de')"
        @click="choosenLanguageClient('de')"
        class="column is-one-quarters-mobile"
      >
        <img class="icon-flag" src="~@/assets/img/flag_translation/de-2.png" />
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/eventBus'
export default {
  methods: {
    choosenLanguageClient (lang) {
      this.$i18n.locale = lang
      this.$store.commit('UPDATE_CHOOSEN_LANGUAGE_CLIENT', lang)
      EventBus.$emit('choosenLanguageComponentEmit', false)
    }
  }
}
</script>

<style scoped>
.cursor {
  cursor: pointer;
}
.icon-flag {
  vertical-align: middle;
  height: 25px;
  width: 40px;
  margin-right: 8px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/formulaire/ChoosenLanguage.vue